import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

export default function Category() {

  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("asc");
  const [categories, setCategories] = useState([]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const activeTab =
    location.pathname === "/products-list" ? "products" : "category";

  useEffect(() => {
    // ✅ API PLACEHOLDER
    axios
      .get("https://api.livestockify.com/api/admin/product-category")
      .then((res) => {
        setCategories(res.data);
      });
  }, []);

  const filteredCategories = categories
    .filter(
      (c) =>
        c?.category && c.category.toLowerCase().includes(search.toLowerCase()),
    )
    .sort((a, b) =>
      sort === "asc"
        ? a.category.localeCompare(b.category)
        : b.category.localeCompare(a.category),
    );

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    axios
      .delete(
        `https://api.livestockify.com/api/admin/product-category/${deleteId}`,
      )
      .then(() => {
        setCategories((prev) => prev.filter((c) => c.id !== deleteId));
        setShowDeleteModal(false);
        setDeleteId(null);
      })
      .catch((err) => {
        console.error("Delete failed", err);
      });
  };

  const getImageUrl = (img) => {
    if (!img) return "/placeholder.png";
    if (img.startsWith("http")) return img;
   
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Main */}
      <div className="flex-1 bg-white rounded-l-2xl p-4 md:p-6">
        {/* Header Tabs */}
        <div className="flex justify-center gap-6 sm:gap-10 mb-6 text-sm sm:text-base">
          <button
            onClick={() => navigate("/category")}
            className={`font-semibold ${
              activeTab === "category"
                ? "text-green-700 underline"
                : "text-gray-700"
            }`}
          >
            Category
          </button>

          <button
            onClick={() => navigate("/products-list")}
            className={`font-semibold ${
              activeTab === "products"
                ? "text-green-700 underline"
                : "text-gray-700"
            }`}
          >
            Products
          </button>
        </div>

        {/* Top Controls */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
          <h2 className="font-semibold text-lg">Product Categories</h2>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 w-full sm:w-auto">
            {/* SEARCH */}
            <div className="relative">
              <input
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="border rounded-md px-4 py-2 pl-10 text-sm w-full sm:w-64"
              />
              {/* <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
        🔍
      </span> */}
            </div>

            {/* SORT */}
            <div className="flex items-center gap-2 w-full sm:w-auto">
              <span className="text-sm font-medium">Sort By</span>
              <select
                value={sort}
                onChange={(e) => setSort(e.target.value)}
                className="border rounded-md px-3 py-2 text-sm"
              >
                <option value="asc">Name (A–Z)</option>
                <option value="desc">Name (Z–A)</option>
              </select>
            </div>

            {/* ADD USER */}
            <button
              onClick={() => navigate("/add-category")}
              className="border rounded-md px-4 py-2 text-sm font-medium flex items-center gap-1 w-full sm:w-auto justify-center"
            >
              + Add Category
            </button>
          </div>
        </div>

        {/* Category Grid */}
        {activeTab === "category" && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCategories.map((cat) => (
              <div
                key={cat.id}
                className="relative rounded-xl overflow-hidden shadow-sm"
              >
                {/* IMAGE */}
                <img
                  src={getImageUrl(cat.imageUrl)}
                  alt={cat.category}
                  className="w-full h-44 items-start object-cover"
                />

                {/* BOTTOM BLUR / GLASS SECTION */}
                <div className="absolute bottom-0 left-0 right-0 bg-white/60 backdrop-blur-sm p-3 sm:p-4">
                  <h3 className="font-semibold text-left text-sm text-green-700">
                    {cat.category}
                  </h3>

                  <p className="text-xs sm:text-sm text-left text-white line-clamp-2">
                    {cat.description}
                  </p>

                  <div className="flex justify-end gap-6 -mt-2 text-sm font-medium">
                    <button
                      onClick={() => navigate(`/product-category/${cat.id}`)}
                      className="text-green-600 hover:underline"
                    >
                      Edit
                    </button>

                    <button
                      onClick={() => openDeleteModal(cat.id)}
                      className="text-red-600 hover:underline"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Products Tab Placeholder */}
        {activeTab === "products" && (
          <div className="text-center text-gray-500 mt-20">
            Products UI will come here
          </div>
        )}
      </div>

      {showDeleteModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-[90%] max-w-sm">
            <h3 className="font-semibold text-lg mb-3">Confirm Deletion</h3>
            <p className="text-sm text-gray-600 mb-5">
              Are you sure you want to proceed with this deletion?
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-1 border rounded-md text-sm"
              >
                Cancel
              </button>

              <button
                onClick={confirmDelete}
                className="px-4 py-1 bg-red-600 text-white rounded-md text-sm"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
